import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  viewBox: "0 0 24 24"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, _cache[0] || (_cache[0] = [
    _createElementVNode("path", {
      fill: "currentColor",
      "fill-rule": "evenodd",
      d: "M9.45 3.442a.75.75 0 0 1 .213.785 7.7 7.7 0 0 0-.359 2.336c0 4.204 3.346 7.59 7.447 7.59a7.3 7.3 0 0 0 2.947-.617.75.75 0 0 1 1.017.913c-1.157 3.648-4.526 6.301-8.518 6.301-4.953 0-8.947-4.082-8.947-9.09 0-3.735 2.217-6.949 5.396-8.347a.75.75 0 0 1 .803.129m6.88.808a.75.75 0 0 0 0 1.5h2.532l-3.33 2.664A.75.75 0 0 0 16 9.75h5a.75.75 0 0 0 0-1.5h-2.862l3.33-2.664A.75.75 0 0 0 21 4.25z",
      "clip-rule": "evenodd"
    }, null, -1)
  ])))
}
export default { render: render }